import { render, staticRenderFns } from "./NormalSearchNav113.vue?vue&type=template&id=12b3a81b&scoped=true"
import script from "./NormalSearchNav113.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav113.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3a81b",
  null
  
)

export default component.exports